import { useEffect } from 'react';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { EdsSelectPropertyNames } from '@/features/eds/enums/EdsSelectPropertyNames';
import { useFetchEDSSelectOptions } from '@/features/eds/hooks/api/useFetchEDSSelectOptions';
import { setNotifications, setNotificationsOptions } from '@/features/notifications/store/notificationsSlice';
import { useEventEffect } from '@/hooks/useEventEffect';
import { ServerSideEvents } from '@/services/ServerEventService/events';
import { useDispatch } from '@/store/hooks';

export const useServerNotificationEvents = (skip?: boolean) => {
  const { data: notificationStatusOptions } = useFetchEDSSelectOptions(
    EdsEntityCodes.AccountNotification,
    EdsSelectPropertyNames.NotificationStatusId,
    skip,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (notificationStatusOptions?.length) {
      dispatch(setNotificationsOptions(notificationStatusOptions));
    }
  }, [notificationStatusOptions?.length]);

  useEventEffect(ServerSideEvents.CurrentNotifications, ({ notifications }) => {
    dispatch(
      setNotifications({ type: ServerSideEvents.CurrentNotifications.name, notifications: notifications || [] }),
    );
  });

  useEventEffect(ServerSideEvents.NewNotifications, ({ notifications }) => {
    dispatch(setNotifications({ type: ServerSideEvents.NewNotifications.name, notifications: notifications || [] }));
  });

  useEventEffect(ServerSideEvents.ChangedNotifications, ({ notifications }) => {
    dispatch(
      setNotifications({ type: ServerSideEvents.ChangedNotifications.name, notifications: notifications || [] }),
    );
  });
};
